import { APPROVAL_TYPES } from 'lib/api/approvals/types';
import SharedApprovalsDrawer from 'pages/mobile/Finance/shared/drawers/ApprovalsDrawer';
import React from 'react';

import { useConfirmingOperationDetail } from '../context';

const ApprovalsDrawer: React.FC = () => {
  const { requestId } = useConfirmingOperationDetail();
  const requestIdNum =
    requestId != null && requestId !== '' ? Number(requestId) : null;
  const approvalPath =
    requestId != null && requestId !== ''
      ? `/finance/confirming/${requestId}/approval`
      : '';

  return (
    <SharedApprovalsDrawer
      approvalType={APPROVAL_TYPES.CONFIRMING}
      entityId={requestIdNum}
      requestId={requestId}
      approvalPath={approvalPath}
      buildApprovalState={(type, userRoles) => ({
        type,
        requestId: requestIdNum ?? undefined,
        userRoles,
      })}
    />
  );
};

export default ApprovalsDrawer;
